import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  NewsThumbnailLists,
  NewsThumbnailListsProps,
} from '~/components/news-thumbnail-list/NewsThumbnailList';
import { RenderFeatureFlag } from '~/components/render-feature-flag/RenderFeatureFlag';
import { useTerminalNavigate } from '~/hooks/use-terminal-navigate/useTerminalNavigate';
import { appPaths } from '~/routes/app-paths';
import { FeatureFlags } from '~/stores/use-feature-flags/feature-flags.types';
import { TabsType } from '~/views/news/utils/utils';

import {
  NoNewsFound,
  WatchlistNewsEmptyState,
} from '../no-news-found/NoNewsFound';
import * as S from './WidgetContent.styles';

export interface WidgetContentProps extends NewsThumbnailListsProps {
  activeTab: TabsType;
  watchlistNewsEmptyState: WatchlistNewsEmptyState | null;
}

export const WidgetContent = ({
  activeTab,
  newsList,
  watchlistNewsEmptyState,
  prevRefetchTimestamp,
  isGrid,
  onSingleNewsClick,
  isLoading,
}: WidgetContentProps) => {
  const { t } = useTranslation(['news']);

  const navigateTerminal = useTerminalNavigate();

  if (activeTab === TabsType.Watchlist && watchlistNewsEmptyState) {
    return <NoNewsFound notFoundCondition={watchlistNewsEmptyState} />;
  }

  const onClickExpand = () => {
    navigateTerminal({
      to: {
        pathname: appPaths.news,
      },
      crumb: {
        isSidebar: true,
        label: t('common:sideNavigation.news'),
      },
    });
  };

  return (
    <S.WidgetContentWrapper>
      <NewsThumbnailLists
        newsList={newsList}
        prevRefetchTimestamp={prevRefetchTimestamp}
        onSingleNewsClick={onSingleNewsClick}
        isGrid={isGrid}
        isLoading={isLoading}
      />
      <RenderFeatureFlag requiredFlag={FeatureFlags.ENABLE_NEWS}>
        <S.ButtonWrapper>
          <S.StyledButton
            label={t('news:viewMoreNews')}
            data-testid="btn-navigate"
            variant="tertiary"
            size="small"
            iconName="Expand"
            onClick={onClickExpand}
          />
        </S.ButtonWrapper>
      </RenderFeatureFlag>
    </S.WidgetContentWrapper>
  );
};
